import { retargetingListApi } from 'common/api/entitiesApi'
import { OwnedEntitySelector } from 'common/components/reloadable/OwnedEntitySelector'
import React from 'react'

interface Props {
  advertiserId?: number
  value?: number | number[]
  onChange?: (value?: number | number[]) => void
  style?: React.CSSProperties
  disabled?: boolean
  placeholder?: string
  multiple?: boolean
  excludeFailed?: boolean
}

export const RetargetingListSelector = ({
  advertiserId,
  value,
  onChange,
  style,
  disabled,
  placeholder,
  multiple,
  excludeFailed,
}: Props) => {
  function loadEntity(id: number) {
    return retargetingListApi.getOne(id)
  }

  function searchEntities(search: string, size: number, page: number, advId?: number) {
    return retargetingListApi.list('name', 'asc', search, advId, excludeFailed, { query: { size, page } })
  }

  return (
    <OwnedEntitySelector
      ownerId={advertiserId}
      value={value}
      onChange={onChange}
      loadEntity={loadEntity}
      searchEntities={searchEntities}
      placeholder={placeholder}
      disabled={disabled}
      style={style}
      errorText="Can't load Retargeting Lists"
      multiple={multiple}
    />
  )
}
